export enum DynamicLoaderAssets {
  GoogleMapsScript = 'https://maps.googleapis.com/maps/api/js?v=weekly&libraries=places,geometry,marker&key={TOKEN}&callback=Function.prototype',
  Intercom = 'https://widget.intercom.io/widget/tnpm2lgx',
  ReCaptcha = 'https://www.google.com/recaptcha/api.js?render=explicit&onload=ng2recaptchaloaded&hl={TOKEN}',
  TypeformSurveyScript = 'https://embed.typeform.com/next/embed.js',
}
